/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

/**
 * An enumeration of the groups of ledger accounts
 */
export enum EnumAccountGroup {
    /**
     * The account group for inland.
     */
    Inland = 1,
    /**
     * The account group representing the European Economic Community.
     */
    EEC = 2,
    /**
     * The account group for transactions to abroad.
     */
    Abroad = 3,
    /**
     * The account group for transactions within the same enterprise.
     */
    Enterprise = 4,
    /**
     * The account group representing tax free bookings.
     * This value is purely technical, and not allowed for use in addresses.
     */
    TaxFree = 5,
    /**
     * The account group representing reverse charge bookings.
     * This value is purely technical, and not allowed for use in addresses.
     */
    ReverseCharge = 6,
}
